import styled from 'styled-components';
import { up } from 'styled-breakpoints';

export const LessonMetaContainer = styled.div`
  border: 1px solid ${({ theme: { colors } }): string => colors.lightGray};
`;

export const LessonTitleAndButtonsContainer = styled.div`
  padding: ${({ theme: { spacing } }): string => spacing.md1};

  ${up('tablet-landscape')} {
    padding-top: ${({ theme: { spacing } }): string => spacing.md4};
    padding-right: ${({ theme: { spacing } }): string => spacing.md4};
    padding-left: ${({ theme: { spacing } }): string => spacing.md4};
  }
`;

export const LessonTitleContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${({ theme: { spacing } }): string => spacing.sm3};
`;

export const LessonTitleContainer = styled.div`
  margin-right: ${({ theme: { spacing } }): string => spacing.sm3};
  max-width: 75%;
`;

export const EllipsisDropdownContainer = styled.div`
  display: flex;
  padding-top: ${({ theme: { spacing } }): string => spacing.md1};
`;

export const LessonNav = styled.div`
  white-space: nowrap;
  padding-left: ${({ theme: { spacing } }): string => spacing.md1};
  padding-bottom: ${({ theme: { spacing } }): string => spacing.md1};
  padding-right: ${({ theme: { spacing } }): string => spacing.md1};
  overflow-x: scroll;

  ${up('tablet-landscape')} {
    padding-right: ${({ theme: { spacing } }): string => spacing.md4};
    padding-left: ${({ theme: { spacing } }): string => spacing.md4};
  }
`;

export const LessonInfoContainer = styled.div`
  max-width: 48rem;
`;

export const LessonInfoHeader = styled.div`
  display: flex;
`;

export const LessonInfoText = styled.div`
  color: ${({ theme: { colors } }): string => colors.nearBlack};
`;

export const LessonInfoList = styled.ul`
  margin-bottom: ${({ theme: { spacing } }): string => spacing.md1};

  > * + * {
    margin-top: ${({ theme: { spacing } }): string => spacing.sm2};
  }
`;

export const LessonInfoListItem = styled.li`
  display: flex;

  p {
    margin-bottom: 0;
    font-size: ${({ theme: { fontSizes } }): string => fontSizes.f3};
    line-height: 1.15;
  }

  p:first-child {
    padding-right: ${({ theme: { spacing } }): string => spacing.md4};
    color: ${({ theme: { colors } }): string => colors.midGray};
    width: 8em;
  }

  p:nth-child(2) {
    text-transform: capitalize;

    span {
      color: ${({ theme: { colors } }): string => colors.red};
      font-family: ${({ theme: { fonts } }): string => fonts.sourceSansBold};
    }
  }
`;

export const LessonTabModalContainer = styled.div`
  background-color: ${({ theme: { colors } }): string => colors.white};
  z-index: 2147483647;
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
`;

export const LessonTabModalContent = styled.div`
  position: absolute;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { spacing } }): string => spacing.md1};

  ${up('tablet-landscape')} {
    padding: ${({ theme: { spacing } }): string => spacing.md4};
  }
`;

export const LessonTabModalMetaContainer = styled.div`
  border-bottom: 1px solid ${({ theme: { colors } }): string => colors.lightGray};

  button {
    margin-top: ${({ theme: { spacing } }): string => spacing.md1};
  }
`;

